import React from 'react';
import styled from 'styled-components';
import { Button } from '@avangard/ui/core';
import { breakpoints } from '@avangard/ui/utils';

import { ListToolbar } from '@modules/layout/moleculas';

type ListFiltersProps = {
    children: React.ReactNode;
    className?: string;
    issetFilters?: boolean;
    hideClearButton?: boolean;
    onResetFilters?: () => void;
};

const List = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;

    > * {
        min-width: 250px;
        margin-bottom: 10px;

        &:not(:last-child) {
            margin-right: 8px;

            ${breakpoints.down('xs')} {
                margin-right: 0;
                margin-bottom: 10px;
            }
        }

        ${breakpoints.down('md')} {
            min-width: auto;
            width: calc(33.3333% - 8px);
        }

        ${breakpoints.down('sm')} {
            width: calc(50% - 8px);
        }

        ${breakpoints.down('xs')} {
            min-width: 100%;
        }
    }

    ${breakpoints.down('md')} {
        width: 100%;
    }
`;

const ResetFilters = styled.div`
    display: block;
`;

const ListFilters = (props: ListFiltersProps): React.ReactElement => {
    const { hideClearButton = true, issetFilters, onResetFilters, children } = props;

    return (
        <ListToolbar>
            <List>{children}</List>

            {!hideClearButton && issetFilters ? (
                <ResetFilters>
                    <Button onClick={onResetFilters}>Сбросить фильтры</Button>
                </ResetFilters>
            ) : null}
        </ListToolbar>
    );
};

export { ListFilters };
